module.exports = __webpack_public_path__ + "static/media/sms-send-correct.06ad9157.png";